import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { VocdoniProvider } from './contexts/vocdoni-context'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <VocdoniProvider>
      <App />
    </VocdoniProvider>
  </React.StrictMode>
)